export enum ProjectSortTypes {
  Name = 'NAME',
  ProjectNumber = 'PROJECT_NUMBER',
  ConstructionArea = 'CONSTRUCTION_AREA',
  LastBooking = 'LAST_BOOKING'
}
